import moment from 'moment';
import { EditorState } from 'draft-js';
import { yupValidateSync } from '@qwealth/qdata';
import { required, stringMaxLengthValidation, validateDate } from '@qwealth/kyc';
import { QTaskForm } from 'data/models/taskForm';
import { QTaskComment } from 'data/models/Activity';

export const validateTask = (values: QTaskForm, editorState: EditorState): Record<string, string | undefined> => {
  const { dueDate, assignee, title, id, isRecurring, endDate, householdQID } = values;
  const isNewTask = id === undefined;
  const hasDueDate = dueDate !== undefined;
  const isNewRecurringTask = isRecurring === true && isNewTask;
  const isRecurringTaskWithDueDate = isRecurring === true && hasDueDate;

  return {
    title: required(title, 'Title'),
    assignee: required(assignee, 'Assignee'),
    householdQID: required(householdQID, 'Household'),
    dueDate:
      (isNewTask || hasDueDate) // New Tasks need the dueDate validated
        ? yupValidateSync(
            dueDate,
            validateDate('dueDate', dueDate ? dueDate : '')
              .test('dueDate', 'Due date cannot be in the past', () => !!id || moment(dueDate).endOf('day').isAfter(moment()))
              .test(
                'dueDate-before-endDate',
                'Due date cannot be after the end date',
                () => !isRecurring || !dueDate || !endDate || moment(dueDate).isSameOrBefore(moment(endDate), 'day'),
              ),
          )
        : undefined, //Do not validate the dueDate for existing tasks with null dueDates
    details: editorState.getCurrentContent().hasText() ? undefined : 'Details is required',
    endDate:
      (isNewRecurringTask || isRecurringTaskWithDueDate)
        ? yupValidateSync(
            endDate,
            validateDate('endDate', endDate)
              .test('endDate', 'End date cannot be in the past', () => !!id || moment(endDate).endOf('day').isAfter(moment()))
              .test(
                'endDate-after-dueDate',
                'End date cannot be before the due date',
                () => !dueDate || !endDate || moment(endDate).isSameOrAfter(moment(dueDate), 'day'),
              ),
          )
        : undefined, // Do not validate endDate for existing recurring tasks with no dueDate
  };
};

export const validateComment = (values: QTaskComment): Record<string, string | undefined> => {
  const { content } = values;

  return {
    content: required(content, 'Comment'),
  };
};
